export class ConfigurationProperties {
    static { this.FRAGMENT_DOMAIN = 'fragment-domain'; }
}
export class Constants {
    static { this.FRAGMENT_URI = '/graphql/execute.json'; }
    static { this.DEFAULT_WWW_DOMAIN = 'https://www.troweprice.com'; }
    static { this.DEFAULT_FRAGMENT_VARIATION = 'master'; }
}
//# sourceMappingURL=constants.js.map